// extracted by mini-css-extract-plugin
module.exports = {"navigationButton":"styles_navigationButton__35aZI","navigationButtonInner":"styles_navigationButtonInner__R9U5i utils_commonFlexSpaceBetween__fwKOa","text":"styles_text__BbmVj"};